import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('admin_token');
  const adminUserRaw = localStorage.getItem('admin_user');
  const location = useLocation();

  if (!token) {
    // Redirect to login if unauthenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const adminUser = adminUserRaw ? JSON.parse(adminUserRaw) : null;

  if (allowedRoles && (!adminUser || !allowedRoles.includes(adminUser.role))) {
    // Trigger sweetalert when component mounts
    Swal.fire({
      title: 'Access Denied',
      text: 'You do not have permission to view this page.',
      icon: 'warning',
      confirmButtonColor: '#0ea5e9',
      background: '#ffffff',
      color: '#111827',
    }).then(() => {
        window.location.href = '/admin/dashboard';
    });
    
    // Return null while redirect is happening
    return null;
  }

  return <>{children}</>;
};
